<script setup>
import { ref, watch } from 'vue';

// Props to control the progress bar from the parent component
const props = defineProps({
  progress: {
    type: Number,
    default: 0
  }
});
</script>

<template>
  <div class="progress-container">
    <div class="progress-bar-wrapper">
      <div class="progress-bar" :style="{ width: props.progress + '%' }"></div>
    </div>
    <div class="progress-text">{{ props.progress }}%</div>
  </div>
</template>

<style scoped>
.progress-container {
  width: 100%;
  max-width: 500px;
  margin: 20px auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.progress-bar-wrapper {
  width: 100%;
  height: 20px;
  background-color: #e0e0e0;
  border-radius: 10px;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  background-color: #4CAF50;
  width: 0%;
  transition: width 0.05s linear;
}

.progress-text {
  font-weight: bold;
}
</style>